import styled from '@emotion/styled';

export const ActivatedGiftsContainer = styled('div')`
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ReceiptIconContainer = styled('div')`
  cursor: pointer;
`;
